import { Button, Grid, Input, Spacer } from '@nextui-org/react'
import { CheckSquare, Square } from 'phosphor-react'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { useHistory, useParams } from 'react-router-dom'
import { app } from '../../../services/feathers'
import { checkFeatureFlag } from '../../../utils/featureFlag'
import LayoutOnboardingPages from '../components/LayoutOnboardingPages/LayoutOnboardingPages'
import * as s from './index.styles'

// up
const ResetPassword = () => {
  const { handleSubmit } = useForm()
  const history = useHistory()
  const { token } = useParams()
  const { t } = useTranslation(['resetPassword', 'common', 'login'], {
    useSuspense: false,
  })

  const [password, setPassword] = useState('')
  const [passwordBis, setPasswordBis] = useState('')

  const [hasUppercase, setHasUppercase] = useState(null)
  const [hasLowercase, setHasLowercase] = useState(null)
  const [hasNumber, setHasNumber] = useState(null)
  const [hasSpecial, setHasSpecial] = useState(null)

  const checkNumber = (myString) => /\d/.test(myString)
  const checkUppercase = (myString) => /[A-Z]/.test(myString)
  const checkLowercase = (myString) => /[a-z]/.test(myString)
  const checkSpecial = (myString) => {
    const specials = /[!@#$%^&*(),.?":{}|<>]/
    return specials.test(myString)
  }
  const checkPasswordBis = (myString) => myString === password && password
  const checkPasswordBisReverse = (myString) =>
    myString === passwordBis && passwordBis

  const handlePasswordChange = (e) => {
    setPassword(e.target.value)
    setHasNumber(checkNumber(e.target.value))
    setHasUppercase(checkUppercase(e.target.value))
    setHasLowercase(checkLowercase(e.target.value))
    setHasSpecial(checkSpecial(e.target.value))
    setPasswordBis(checkPasswordBisReverse(e.target.value))
  }

  const handlePasswordBisChange = (e) => {
    setPasswordBis(checkPasswordBis(e.target.value))
  }

  const resetPassword = async () => {
    const email = Buffer.from(token, 'base64').toString('ascii')

    if (email) {
      try {
        app
          .service('talent-reset-password')
          .create({
            email,
            password,
            domainJ2BD: checkFeatureFlag ? true : undefined,
          })
          .then(() => {
            history.push('/app/jobs')
            toast.success(t('login:resetPassword.success', 'Succès'))
          })
      } catch (err) {
        console.log(err)
      }
    }
  }

  return (
    <s.ResetPassword>
      <header>
        <h3>
          {t(
            'login:resetPassword.resetPassword',
            'Réinitialisez votre mot de passe',
          )}
        </h3>
      </header>

      <form onSubmit={handleSubmit(resetPassword)}>
        <Grid.Container gap={2}>
          <Spacer y={1.3} />

          <Grid xs={12}>
            <Input.Password
              labelPlaceholder="Mot de passe"
              fullWidth
              size="lg"
              onChange={handlePasswordChange}
            />
          </Grid>
          <Spacer y={0.3} />
          <Grid xs={12}>
            <Input.Password
              labelPlaceholder="Confirmation du mot de passe"
              fullWidth
              size="lg"
              onChange={handlePasswordBisChange}
            />
          </Grid>

          <Grid xs={6}>
            <div className="checklist">
              {hasUppercase ? (
                <CheckSquare size={24} />
              ) : (
                <Square size={24} color="#9e9e9e" />
              )}
              <Spacer x={0.5} />
              <p className={`${hasUppercase ? 'isValid' : 'isInvalid'}  `}>
                {t('login:resetPassword.upperCase', 'Une majuscule')}
              </p>
            </div>
          </Grid>

          <Grid xs={6}>
            <div className="checklist">
              {hasLowercase ? (
                <CheckSquare size={24} />
              ) : (
                <Square size={24} color="#9e9e9e" />
              )}
              <Spacer x={0.5} />
              <p className={`${hasLowercase ? 'isValid' : 'isInvalid'}  `}>
                {t('login:resetPassword.tinyCase', 'Une minuscule')}
              </p>
            </div>
          </Grid>

          <Grid xs={6}>
            <div className="checklist">
              {hasSpecial ? (
                <CheckSquare size={24} />
              ) : (
                <Square size={24} color="#9e9e9e" />
              )}
              <Spacer x={0.5} />
              <p className={`${hasSpecial ? 'isValid' : 'isInvalid'}  `}>
                {t('login:resetPassword.specialCase', 'Un caractère spécial')}
              </p>
            </div>
          </Grid>

          <Grid xs={6}>
            <div className="checklist">
              {hasNumber ? (
                <CheckSquare size={24} />
              ) : (
                <Square size={24} color="#9e9e9e" />
              )}
              <Spacer x={0.5} />
              <p className={`${hasNumber ? 'isValid' : 'isInvalid'}  `}>
                {t('login:resetPassword.numberCase', 'Un chiffre')}
              </p>
            </div>
          </Grid>

          <Grid xs={6}>
            <div className="checklist">
              {password.length > 7 ? (
                <CheckSquare size={24} />
              ) : (
                <Square size={24} color="#9e9e9e" />
              )}
              <Spacer x={0.5} />
              <p
                className={`${password.length > 7 ? 'isValid' : 'isInvalid'}  `}
              >
                {t('login:resetPassword.digitCase', 'Au moins 8 caractères')}
              </p>
            </div>
          </Grid>

          <Grid xs={6}>
            <div className="checklist">
              {passwordBis ? (
                <CheckSquare size={24} />
              ) : (
                <Square size={24} color="#9e9e9e" />
              )}
              <Spacer x={0.5} />
              <p className={`${passwordBis ? 'isValid' : 'isInvalid'}  `}>
                {t(
                  'login:resetPassword.passwordConfirm',
                  'Confirmation du mot de passe',
                )}
              </p>
            </div>
          </Grid>
          <Grid xs={12}>
            <Button
              type="submit"
              color="primary"
              size="lg"
              disabled={
                !hasUppercase ||
                !hasLowercase ||
                !hasSpecial ||
                !hasNumber ||
                password.length < 8 ||
                !passwordBis
              }
            >
              {t('login:askNewPassword.submitBtn')}
            </Button>
          </Grid>
        </Grid.Container>
      </form>
    </s.ResetPassword>
  )
}

const WreapedResetPassword = () => (
  <LayoutOnboardingPages type="reset-password">
    <ResetPassword />
  </LayoutOnboardingPages>
)

export default WreapedResetPassword
